import type { BankReconciliationTransaction } from "@/types/bankReconciliation";
import type { Currency } from "@/types";
import { TransactionSpreadsheetRow } from "./TransactionSpreadsheetRow";

const JOURNAL_DRAG_TYPE = "application/x-budy-journal-entry";

type Props = {
  item: BankReconciliationTransaction;
  isDropTarget: boolean;
  isMatching: boolean;
  canAcceptJournal: boolean;
  onAcceptJournal?: () => void;
};

export function BankTransactionRow({
  item,
  isDropTarget,
  isMatching,
  canAcceptJournal,
  onAcceptJournal,
}: Props) {
  const currency = item.currency as Currency;
  const highlight = isDropTarget || canAcceptJournal;

  return (
    <div
      role={canAcceptJournal ? "button" : undefined}
      tabIndex={canAcceptJournal ? 0 : undefined}
      onClick={canAcceptJournal ? onAcceptJournal : undefined}
      onKeyDown={
        canAcceptJournal
          ? (event) => {
              if (event.key === "Enter" || event.key === " ") {
                event.preventDefault();
                onAcceptJournal?.();
              }
            }
          : undefined
      }
      className={`h-full transition ${
        canAcceptJournal ? "cursor-pointer" : ""
      } ${isMatching ? "opacity-60" : ""}`}
    >
      <TransactionSpreadsheetRow
        description={item.description}
        date={item.date}
        amount={item.amount}
        currency={currency}
        highlight={highlight}
      />
    </div>
  );
}

export { JOURNAL_DRAG_TYPE };
